import { environment } from 'src/environments/environment'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(private httpClient: HttpClient) {}

  listEndsUser({ limit, page, mobile, email }: { limit?: number; page?: number; mobile?: string; email?: string }) {
    let url = `${environment.apiURL}api/team/user/list/?role=customer&limit=${limit}&page=${page}`
    if (mobile) url += `&mobile=${encodeURIComponent(mobile)}`
    if (email) url += `&email=${encodeURIComponent(email)}`
    return this.httpClient.get(url)
  }

  viewCustomer({ customerId }: { customerId: string }) {
    return this.httpClient.get(
      `${environment.apiURL}api/team/user/view-customer-info/${customerId}`,
    )
  }

  viewUser() {
    return this.httpClient.get(`${environment.apiURL}api/team/user/view/`)
  }
}
